'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var React = require('react');
var Chip_web_styles = require('../Chip.web.styles.cjs');
var ShowMore_web = require('../ShowMore/ShowMore.web.cjs');
var ChipContext = require('../context/ChipContext.cjs');

/**
 * Chip.Filter is a component that allows you to display a list of chips and a "Show All" button.
 * These chips are used to filter a list of items.
 *
 * @scope Core
 */ const Filter = ({ maxVisible = 3, onRemove, children, customCss, ...rest })=>{
    const [expanded, setExpanded] = React.useState(false);
    const chips = React.Children.toArray(children);
    const visibleChips = React.useMemo(()=>expanded ? chips : chips.slice(0, maxVisible), [
        expanded,
        chips,
        maxVisible
    ]);
    const hasOverflow = chips.length > maxVisible;
    const hiddenCount = Math.max(chips.length - maxVisible, 0);
    return /*#__PURE__*/ jsxRuntime.jsx(ChipContext.ChipContext.Provider, {
        value: {
            variant: "single",
            selectedValues: "",
            onSelectionChange: ()=>undefined,
            disabled: false,
            hiddenCount,
            isFilterableItem: true,
            onRemove
        },
        children: /*#__PURE__*/ jsxRuntime.jsxs("div", {
            css: [
                Chip_web_styles.chipBase,
                customCss
            ],
            "data-testid": "aviary-chip-filter",
            ...rest,
            children: [
                visibleChips,
                hasOverflow && /*#__PURE__*/ jsxRuntime.jsx(ShowMore_web.ShowMore, {
                    onClick: ()=>setExpanded((prev)=>!prev),
                    expanded: expanded
                })
            ]
        })
    });
};
Filter.displayName = "Chip.Filter";

exports.Filter = Filter;
//# sourceMappingURL=Filter.web.cjs.map
